import { ref, computed, onMounted, onUnmounted } from "vue-demi";
export default (target, threshold = 0.5, onThresholdReached, options = {}) => {
  const { once = true } = options;
  const thresholdReached = ref(false);
  const targetsFired = ref([]);
  const isArrayOfTargets = computed(() => Array.isArray(target.value));
  let observer = null;
  const stop = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };
  const intersectionOfArrayItemHandler = (entry) => {
    if (entry.intersectionRatio >= threshold && !targetsFired.value.includes(entry.target)) {
      onThresholdReached(entry);
      targetsFired.value.push(entry.target);
      if (targetsFired.value.length >= target.value?.length) {
        stop();
      }
    }
  };
  const intersectionHandler = (entry) => {
    if (entry.intersectionRatio >= threshold && !(once && thresholdReached.value)) {
      onThresholdReached(entry);
      thresholdReached.value = true;
      if (once) {
        stop();
      }
    }
  };
  onMounted(() => {
    if (!target.value) {
      return;
    }
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const callback = isArrayOfTargets.value ? intersectionOfArrayItemHandler : intersectionHandler;
          callback(entry);
        });
      },
      {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        rootMargin: options.rootMargin ?? ""
      }
    );
    if (isArrayOfTargets.value) {
      target.value.forEach((item) => {
        const element = item.$el ?? item;
        if (element instanceof Element) {
          observer?.observe(element);
        }
      });
    } else {
      const element = target.value.$el ?? target.value;
      if (element instanceof Element) {
        observer?.observe(element);
      }
    }
  });
  onUnmounted(() => {
    stop();
  });
  return {
    thresholdReached,
    stop
  };
};
